import React, { useEffect } from "react";
import LandingNav from "@/components/marketing/LandingNav";
import Hero from "@/components/marketing/Hero";
import Problem from "@/components/marketing/Problem";
import FlowNarrative from "@/components/marketing/FlowNarrative";
import Workflow from "@/components/marketing/Workflow";
import Intelligence from "@/components/marketing/Intelligence";
import Team from "@/components/marketing/Team";
import LiveProduct from "@/components/marketing/LiveProduct";
import Trust from "@/components/marketing/Trust";
import OrgDeployment from "@/components/marketing/OrgDeployment";
import Executive from "@/components/marketing/Executive";
import SeeInAction from "@/components/marketing/SeeInAction";
import BrandStatement from "@/components/marketing/BrandStatement";
import Contact from "@/components/marketing/Contact";

export default function Landing() {
  useEffect(() => {
    const prev = document.title;
    document.title = "GovFlowState — Legislative Workflow & Intelligence Platform";
    return () => { document.title = prev; };
  }, []);

  return (
    <div className="min-h-screen bg-[#F5F7FA] font-sans text-brand-ink" data-testid="landing-page">
      <LandingNav />
      <main>
        <Hero />
        <Problem />
        <FlowNarrative />
        <Workflow />
        <Intelligence />
        <Team />
        <LiveProduct />
        <Trust />
        <OrgDeployment />
        <Executive />
        <SeeInAction />
        <BrandStatement />
        <Contact />
      </main>
    </div>
  );
}
